import { useAuthMutations } from '@/modules/authentication/contracts';

import { useRegistrationStore } from '../stores/registration.store';

export const useUpdateProfile = () => {
	const { registration } = useRegistrationStore();
	const { updateProfileMutation } = useAuthMutations();
	const execute = async () => {
		try {
			await updateProfileMutation.mutateAsync({
				body: {
					education: {
						educationLevel:   registration.education.educationLevel,
						graduationDate:   registration.education.graduationDate,
						graduationStatus: registration.education.graduationStatus,
					},
					jobPreference: {
						currentAnnualSalary:    registration.jobPreference.currentAnnualSalary,
						expectedAnnualSalary:   registration.jobPreference.expectedAnnualSalary,
						openToAnyLocations:     registration.jobPreference.openToAnyLocations,
						preferredLocationIds:   registration.jobPreference.preferredLocationIds,
						preferredOccupationIds: registration.jobPreference.preferredOccupationIds,
					},
					personalInfo: {
						provinceId:  registration.personalInfo.provinceId,
						dateOfBirth: registration.personalInfo.dateOfBirth,
						gender:      registration.personalInfo.gender,
						phoneNumber: registration.personalInfo.phoneNumber,
					},
					workHistory: {
						industryId:       registration.workHistory.industryId,
						occupationId:     registration.workHistory.occupationId,
						companyName:      registration.workHistory.companyName,
						employmentStatus: registration.workHistory.employmentStatus,
						hideCompanyName:  registration.workHistory.hideCompanyName,
						jobChangeCount:   registration.workHistory.jobChangeCount,
					},
				},
			});
		}
		catch (error) {
			console.log('🚀 ~ execute ~ error:', error);
			throw error;
		}
	};

	return { execute };
};
